const storeName = 'WISHLISTS';

export default {
    SET_LOADING: `${storeName}.SET_LOADING`,
    LOAD_WISHLISTS: `${storeName}.LOAD_WISHLISTS`,
    SET_WISHLISTS: `${storeName}.SET_WISHLISTS`,
    MOVE_TO_WISHLIST: `${storeName}.MOVE_TO_WISHLIST`,
    CLEAR_WISHLISTS: `${storeName}.CLEAR_WISHLISTS`,
};
